import { AddSliderImagesRequest, InventoryActions } from "../domain/inventory";
import { addSliderImagesService } from "../infrastructure/services/addSliderImagesService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const addSliderImages = {
    async execute(
        position: number,
        isSliderEdited: string,
        isBigImageEdited: string,
        reference: string,
        slider: File | null,
        bigImage: File | null
    ): Promise<void> {
        const request: AddSliderImagesRequest = await InventoryActions().addSliderImagesRequest(
            position,
            isSliderEdited,
            isBigImageEdited,
            reference,
            slider,
            bigImage
        );
        await addSliderImagesService.execute(await tokenValidation.execute(), request);
    },
};


